import React, { useState, useEffect } from "react";
import { CustomTitle } from "../../components";
import { Flex, Tooltip, Switch, Typography } from "antd";
import { AiFlowToggle, GetAiToggleStatus } from "../../api's/settings";
import { useToken } from "../../common/helper"
import { useSpin } from "../../components/SpinContext";

const { Text, Paragraph } = Typography;

const AIworkflow = ({ title, unauthorize }) => {
  const { token } = useToken();
  const [toggle, setToggle] = useState(false);
  const { showSpin, hideSpin } = useSpin();

  useEffect(() => {
    showSpin();
    GetAiToggleStatus(token)
      .then((res) => {
        const data = res?.data?.data?.data;
        
        if (data && data.ai_enabl !== undefined) {
          setToggle(data.ai_enabl);
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  }, [token]);

  const toggleSwitch = (checked) => {
    setToggle(checked);
    showSpin();

    const model = {
      ai_enabl: checked ? "true" : "false",
    };

    AiFlowToggle(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data && data.data?.is_success) {
          console.log("AI flow toggle successful:", data.data.data);
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  return (
    <div className="settings-content-wrapper">
      <CustomTitle
        text={title}
        fontSize={20}
        fontWeight="700"
        lineHeight="32px"
        color="#000"
        marginBottom={24}
      />

      <Flex
        justify="space-between"
        align="center"
        style={{
          background: "#fff",
        }}
      >
        <div>
          <Text
            strong
            style={{ fontSize: "12px", fontWeight: 600, color: "#000" }}
          >
            Enable AI
          </Text>
          <Paragraph style={{ margin: 0, fontSize: "12px", color: "#4B4B4B" }}>
            Show options to use AI to resolve alerts
          </Paragraph>
        </div>

      
          <Switch
            checked={toggle}
            onChange={toggleSwitch}
            style={{
              backgroundColor: toggle ? "#000" : undefined,
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
            }}
          />
      </Flex>
    </div>
  );
};

export default AIworkflow;
